import { TagWrapper } from '@/home/HeroCardsReturnUser/LinkCards/VDPLinks/StatusTag';
import { addNewestInventorySortToCvnaId } from '@/home/RecentSearches/RecentSearches';
import { RecentSearch } from '~/contracts/home';
import { nativeSrpPayload } from '~/native/home/utils';
import RecentSearchHeart from './RecentSearchHeart';

type OwnProps = {
  links: RecentSearch[];
};

export default function RecentSearchLink({ links }: OwnProps) {
  return links.map(link => {
    const {
      totalNewVehicles = 0,
      cvnaId,
      display: { name },
      savedSearch
    } = link;

    return (
      <div
        key={cvnaId}
        className="py-[18px] first:pt-0 last:pb-0"
        data-qa="recent-search-links"
      >
        <a
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: 'Search Card',
            type: 'recent',
            item: 'search'
          })}
          data-native-payload={nativeSrpPayload}
          href={`/cars/filters?cvnaid=${addNewestInventorySortToCvnaId(
            cvnaId
          )}`}
          className="grid grid-cols-[1fr_20px] items-center gap-xl text-blue-6"
        >
          <div className="flex flex-nowrap  items-center gap-md">
            <div className="truncate tl-body-m">
              {savedSearch?.name ?? name}
            </div>
            {totalNewVehicles > 0 ? (
              <TagWrapper className="bg-marketplace-purple">
                {totalNewVehicles} New
              </TagWrapper>
            ) : null}
          </div>
          <RecentSearchHeart search={link} />
        </a>
      </div>
    );
  });
}
